<template>
  <div class="appRedirect">
    <div class="appRedirect__langChange">
      <LangChange />
    </div>
    <div class="appRedirect__wrapper">
      <Loading v-if="loading" />
      <div v-if="!error" class="appRedirect-container">
        <h1 class="title">{{ $t('welcomeToApteekkiPuhelu') }}</h1>
        <p class="subtitle">
          {{ $t('openApp') }}
          <a id="redirect-link" href="#">
            {{ $t('clickHere') }}
          </a>
          {{ $t('downloadApp') }}
        </p>
      </div>
      <span v-if="error" class="appRedirect-errorMessage">
        {{ $t('platformUnsupported') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import Loading from '@/views/Loading.vue';
import LangChange from '@/views/Language.vue';

@Options({
  name: 'AppRedirect',
  components: {
    Loading,
    LangChange
  },
  data() {
    return {
      modalActive: null,
      loading: null,
      error: false
    };
  },
  mounted() {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      // eslint-disable-next-line
      !(window as any).MSStream;
    const isAndroid = /Android/.test(navigator.userAgent);

    const linkElement = document.getElementById(
      'redirect-link'
    ) as HTMLAnchorElement;

    if (linkElement) {
      if (isIOS) {
        linkElement.href = process.env.VUE_APP_APPSTORE_LINK;
        window.location.href = process.env.VUE_APP_APPSTORE_LINK;
      } else if (isAndroid) {
        linkElement.href = process.env.VUE_APP_GOOGLE_MARKET_LINK;
        window.location.href = process.env.VUE_APP_GOOGLE_MARKET_LINK;
      } else {
        this.error = true;
      }
    } else {
      console.log('Element with id "redirect-link" not found');
    }
  }
})
export default class AppRedirect extends Vue {}
</script>

<style lang="scss" scoped>
.appRedirect {
  position: relative;
  width: 100%;
  height: 100%;
  .appRedirect__langChange {
    position: absolute;
    width: 172px;
    height: max-content;
    right: 32px;
    top: 32px;
    background-color: $light-grey;
  }
  .appRedirect__wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $light-grey;
    @media (min-width: 900px) {
      width: 100%;
    }
    .appRedirect-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 393px;
      height: max-content;
      padding: 24px 32px;
      border-radius: 8px;
      background: $white;
      font-size: $eighteenSize;
      .title {
        font-size: 24px;
        font-family: 'Ubuntu-Medium';
        margin: 0 auto;
        margin-bottom: 30px;
      }
      .subtitle {
        font-weight: 400;
        font-size: $fourteenSize;
        line-height: 14px;
        color: $grey;
      }
    }
    .appRedirect-errorMessage {
      font-size: 24px;
      font-family: 'Ubuntu-Medium';
      color: $red;
      padding: 24px 32px;
    }
  }
}
</style>
